var XmlSlides = function() {
    var _this = this,
        _pageSize = { w: 900, h: (viewSettings.isRedesign ? 1230 : 1200) };

    function _generateSinglePageItem(page) {
        var xmlSinglePage = {
                w: _pageSize.w,
                h: _pageSize.h,
                originalSize: {
                    w: _pageSize.w,
                    h: _pageSize.h
                },
                inx: page.inx
            },
            slideNode,
            pageHtmlNode;

        if (page.additional_page) {
            xmlSinglePage.src = page.backgroundImage;
            xmlSinglePage.additional_page = true;
            xmlSinglePage.thumbImage = xmlSinglePage.mediumImage = xmlSinglePage.largeImage = { src: page.backgroundImage, h: page.h, w: page.w };
            xmlSinglePage.w = page.w;
            xmlSinglePage.h = page.h;
            xmlSinglePage.originalSize = { w: xmlSinglePage.w, h: xmlSinglePage.h };
            xmlSinglePage.pid = page.inx;

            if (viewSettings.isRedesign === true) {
                xmlSinglePage.pins = page.pins;
            }
        } else {
            slideNode = document.createElement('div'),

                pageHtmlNode = _generatePageHtml(page);
            slideNode.className = 'xml-slide html-slide';
            slideNode.appendChild(pageHtmlNode);

            xmlSinglePage.html = slideNode;
            xmlSinglePage.htmlSlide = true;
            xmlSinglePage.thumbImage = { src: page.src };
        }


        return xmlSinglePage;
    }

    function _generateDoubleModeSlides(items, isRelatedBrochure) {
        var doublePagesArr = [];

        for (var i = 0, len = items.length; i < len; i++) {
            var item = items[i];

            if (i == 0) {
                item.logoTest = true;
            }

            doublePagesArr.push(_generateDoublePageItem(item));
        }

        return doublePagesArr;
    }

    function _generatePageHtml(page, inx, isSingle) {
        var pageHtml,
            pageNode = document.createElement('div'),
            pageWrapNode = document.createElement('div');

        pageNode.className = (typeof inx !== 'undefined' ? 'page page-' + inx : 'page') + (page.number_of_products === '12' ? ' p-twelve' : '') + (page.number_of_products === '6' ? ' p-six' : '') + (page.appPromoSlide || page.cover ? '' : (' slide-xml' + (page.pageLogo ? ' slide-flex-column ' : '')));
        if (typeof page.inx !== 'undefined') {
            pageNode.setAttribute('data-page-inx', page.inx);
        }

        pageNode.setAttribute('data-slot-inx', inx);

        pageWrapNode.className = 'xml-slide-inner-wrap';

        if (page.pageLogo) {
            var pageLogoWrap = document.createElement('a'),
                productsWrap = document.createElement('div'),
                logoInnerWrap = document.createElement('div');

            logoInnerWrap.className = 'p-inner-wrap p-logo';
            logoInnerWrap.style.backgroundImage = 'url(' + page.pageLogo + ')';

            pageLogoWrap.className = 'product-zone product-pin-zone active product-wrap page-logo-wrap';
            pageLogoWrap.appendChild(logoInnerWrap);


            if (page.pageLogoUrl) {
                pageLogoWrap.setAttribute('data-url', page.pageLogoUrl);
                pageLogoWrap.setAttribute('href', page.pageLogoUrl);
                pageLogoWrap.setAttribute('target', '_blank');
                pageLogoWrap.setAttribute('rel', 'nofollow noopener');
            } else {
                pageLogoWrap.className += ' no-hover ';
            }

            productsWrap.className = 'products-wrap';
            productsWrap.innerHTML = page.html.innerHTML;

            pageNode.appendChild(pageLogoWrap);
            pageNode.appendChild(productsWrap);
        } else {
            if (typeof page.html.innerHTML !== 'undefined') {
                pageNode.innerHTML = page.html.innerHTML;
            } else {
                pageNode.innerHTML = page.html;
            }
        }

        if (page.backgroundColor) {
            pageNode.style.backgroundColor = page.backgroundColor;
        }

        if (page.backgroundImage) {
            if (page.additional_page) {
                pageNode.appendChild(_generateImgElem(page.backgroundImage, page.inx));
            } else {
                pageNode.style.backgroundImage = 'url(' + page.backgroundImage + ')';
            }
        }

        return pageNode;
    }

    function _generateDoublePageItem(item) {
        var slideNode = document.createElement('div'),
            page0Node = document.createElement('div'),
            page1Node = document.createElement('div'),
            page0WrapNode = document.createElement('div'),
            page1WrapNode,
            page0 = item[0],
            page1 = item[1];

        slideNode.className = 'xml-slide html-slide double-page-slide';


        if (page0 && page0.html) {
            page0Node = _generatePageHtml(page0, 0);
            slideNode.appendChild(page0Node);
        }

        if (page1 && page1.html) {
            page1Node = _generatePageHtml(page1, 1);
            slideNode.appendChild(page1Node);
        }

        if (item.logoTest) {
            // _pageSize.w = 1200;
            // _pageSize.h = 1500;
        }

        var xmlDoublePage = {
            html: slideNode,
            originalSize: {
                w: _pageSize.w * 2,
                h: _pageSize.h
            },
            pagesSize: [{
                    w: _pageSize.w,
                    h: _pageSize.h
                },
                {
                    w: _pageSize.w,
                    h: _pageSize.h
                },
            ],
            w: _pageSize.w * 2,
            h: _pageSize.h,
            doublePageSlide: true
        };

        return xmlDoublePage;
    }

    function _generateImgElem(src, imgPageInx, alt) {
        var imgWrap = document.createElement('div'),
            img = document.createElement('img');

        img.alt = alt || '';
        img.className = 'slide-img';
        img.setAttribute('data-page-inx', imgPageInx);
        img.src = src;

        imgWrap.className = 'page-inner-wrap';
        imgWrap.appendChild(img);

        return imgWrap;
    }

    function _generataeProductPageTpl(product, page) {
        var pageProductsHtml		= document.createElement('a'),
            pInnerWrap 				= document.createElement('div'),
            pHover 					= document.createElement('div'),
            pImgWrap 				= document.createElement('div'),
            pTextWrap 				= document.createElement('div'),
            pBrandLogoWrapper      = document.createElement('div'),     
            pOfferLabel				= document.createElement('div'),
            pBrandLogo 				= document.createElement('div'),
            pTitle 					= document.createElement('div'),
            pDesc 					= document.createElement('div'),
            pPrice 					= document.createElement('div'),
            pOldPrice 				= document.createElement('div'),
            pWholePrice 			= document.createElement('div'),
            pBottomWrap 			= document.createElement('div'),
            pBtn 					= document.createElement('div'),
            pZone   				= document.createElement('div'),
            pWidth 					= product.grid_size.width,
            pHeight					= product.grid_size.height,
            activeClass 			= product.active == "1" ? ViewConsts.active : ViewConsts.inactive,
            opacitySpan 			= '</span><span></span><span></span><span></span><span></span>';
	        opacity 				= document.createElement('span');
	        opacity.innerHTML = opacitySpan;
	        opacity.className = 'opacity';

        if (pWidth === 1.5) {
            pWidth = 'half';
        }
        //added product-pin-zone wrap class for making zones
        pageProductsHtml.className = 'product-zone product-pin-zone  product-wrap w-' + pWidth + ' h-' + product.grid_size.height + ' ' + activeClass; 

        if (product.productUrl) {
            pageProductsHtml.setAttribute('data-url', product.productUrl);
            pageProductsHtml.setAttribute('href', product.productUrl);
            pageProductsHtml.setAttribute('data-real-url', product.realProductUrl);
            pageProductsHtml.setAttribute('rel', 'nofollow noopener');
        }

        if (product.type) {
            pageProductsHtml.setAttribute('data-product-type', product.type);
        }

        pageProductsHtml.setAttribute('target', '_blank');

        pInnerWrap.className = 'p-inner-wrap';
        pZone.className 	= 'product-pin-zone-inner';

        if (viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined") {
            pHover.className = 'p-hover absl-pos';
            pHover.innerHTML = '<div class="p-hover-btn"><span>' + (viewLang ? viewLang.html_see_more : 'Виж повече') + '</span></div>';
        }


        if (product.type === ViewConsts.Products.logo || product.type === ViewConsts.Products.banner) {
            // var pLogo = document.createElement('div');
            pInnerWrap.className += ' p-logo ';
            pInnerWrap.style.backgroundImage = 'url(' + product.imageUrl + ')';

            pageProductsHtml.appendChild(pInnerWrap);

            return pageProductsHtml;
        }

        if (product.type === ViewConsts.Products.text) {
            pInnerWrap.className += ' p-text ';
            pInnerWrap.innerHTML = '<div class="p-table">' + (product.content || "") + '</div>';

            pageProductsHtml.appendChild(pInnerWrap);

            return pageProductsHtml;
        }
        if (viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined") {
            pInnerWrap.className += ' p-hoverable ';
        }

        if (isMobile === false) {
            if (viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined") {
                pageProductsHtml.appendChild(pHover);
            }
        }
        pInnerWrap.appendChild(pZone);

        pImgWrap.className = 'p-img-wrap';
        pImgWrap.style.backgroundImage = 'url(' + product.imageUrl + ')';

        pTextWrap.className = 'p-txt-wrap';
        pInnerWrap.appendChild(pImgWrap);

        // Discount tag (e.g. Hot offer)
        if (viewSettings.isRedesign === true && page.hide_discount_tag === false && product.discount_tag != false) {
            pOfferLabel.className = 'p-label';
            pOfferLabel.style.color = page.discount_tag_text_color;
            pOfferLabel.style.background = page.discount_tag_background_color;
           	pOfferLabel.setAttribute("background-col", page.discount_tag_text_color);
            pOfferLabel.innerHTML = '<span class="p-label-txt">' + product.discount_tag + '</span>';
        }
        pTitle.className = 'p-title';
        if (viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined"){
        	pTitle.innerHTML = product.title;
        }
       

        pDesc.className = 'p-desc';
        pDesc.innerHTML = product.description;

        pPrice.className = 'p-price';

        if (isNaN(parseFloat(product.price)) === false) {
            product.price = _formatPrice(product.price);
        }

        pPrice.innerHTML = product.price;

        pBottomWrap.className = 'p-bottom-wrap';

        pBtn.className = 'p-btn';
        if (viewSettings.isRedesign === true) {
            pBtn.innerHTML = '<span class="p-btn-label">' + viewLang.html_see_more + '</span>';
        } else {

            pBtn.innerHTML = '<span class="p-btn-label">' + (page.price_in_left ? page.price_currency + ' ' + product.price : product.price + ' ' + page.price_currency) + '</span>';
        }

        if (page.prices_color) {
            pBtn.style.color = page.prices_color;
        }

        if (page.prices_background_color) {
            pBtn.style.backgroundColor = page.prices_background_color;
        }

        pInnerWrap.appendChild(pTextWrap);

        if (viewSettings.isRedesign === true) {
            pWholePrice.className = 'p-whole-price';
            pTextWrap.appendChild(pWholePrice);

        } else {
            pOldPrice.className = 'p-old-price';
            pBottomWrap.appendChild(pOldPrice);
        }

        if (product && product.old_price && product.old_price != product.price) {
            if (isNaN(parseFloat(product.old_price)) === false) {
                product.old_price = _formatPrice(product.old_price);
            }
            if (viewSettings.isRedesign === true) {
                pWholePrice.innerHTML = '<span class="p-old-exact-price"><span class="p-big-amount">' + product.old_price[0] + '.</span><span class="p-small-amount">' + product.old_price[1] + '</span></span>' +
                    '<span class="p-new-exact-price">' + (page.price_in_left ? page.price_currency + ' ' : '') + '<span class="p-big-amount">' + product.price[0] + '.</span><span class="p-small-amount">' + product.price[1] + '</span>' + (!page.price_in_left ? '' + page.price_currency : '') + '</span></span>';
            } else {
                pOldPrice.innerHTML = '<span>' + (page.price_in_left ? page.price_currency + ' ' + product.old_price : product.old_price + ' ' + page.price_currency) + '</span>';
            }

        } else {
            if (viewSettings.isRedesign === true) {
            	if (isNaN(parseFloat(product.price)) === false) {
               		pWholePrice.innerHTML = '<span class="p-one-price">' + (page.price_in_left ? page.price_currency + ' ' : '') + '<span class="p-big-amount">' + product.price[0] + '.</span><span class="p-small-amount">' + product.price[1] + '</span>'  + (!page.price_in_left ? ' ' + page.price_currency : '') +  '</span></span>';
            	}else{
            		pTitle.className += ' p-title-more-text';
            	}
            } else {
                pOldPrice.innerHTML = '&nbsp;<span></span>';
            }
        }

        if (viewSettings.isRedesign === true) {
            pInnerWrap.appendChild(pOfferLabel);
        }

        if (viewSettings.isRedesign === true) {
        	if(product.brand_logo != false && page.hide_brands_logos === false){
                pBrandLogoWrapper.className = 'p-brand-logo-wrapper'
        		pBrandLogo.className += "p-brand-logo";
	            pBrandLogo.style.backgroundImage = 'url('+product.brand_logo+')';
	            pInnerWrap.appendChild(pBrandLogoWrapper);
                pBrandLogoWrapper.appendChild(pBrandLogo);
        		pTitle.innerHTML = _formatTitle(product.title);
        	}else{
        		pTitle.className += ' p-two-rows-title';
        		pTitle.innerHTML = product.title;
        	}
        }
        pTextWrap.appendChild(pTitle);

        if (viewSettings.isRedesign === true && typeof product.title == 'string' && (product.title).length > 16 && !pTitle.classList.contains('p-two-rows-title')) {
       		pTitle.appendChild(opacity);
        }
        // pageProductsHtml.appendChild(pDesc);
        // pageProductsHtml.appendChild(pPrice);

        pBottomWrap.appendChild(pBtn);
        pInnerWrap.appendChild(pBottomWrap);

        if (activeClass == ViewConsts.inactive) {
            var inactiveLabel = document.createElement('div');

            inactiveLabel.className = "p-inactive-label";
            inactiveLabel.textContent = viewLang.pInactiveLabel;

            pageProductsHtml.appendChild(inactiveLabel);
        }


        pageProductsHtml.appendChild(pInnerWrap);

        return pageProductsHtml;
    }

    function _buildSingleContent(data, frontCover, backCover, promoLastPage, isRelatedBrochure, promoSpecificLastPage) {
        var dataArr = []


        for (var i = 0, len = data.length; i < len; i++) {
            var item = data[i];

            dataArr.push(_generateSinglePageItem(item));
        }


        if (promoLastPage) {
            dataArr.push(promoLastPage);
        }

        if (typeof specificPromoPage !== 'undefined' && specificPromoPage && promoSpecificLastPage) {
            dataArr.push(promoSpecificLastPage);
        }

        if (backCover) {
            dataArr.push(backCover);
        }

        return dataArr;
    }

    function _buildDoubleContent(data, frontCover, backCover, promoLastPage, isRelatedBrochure, promoSpecificLastPage, relatedPage) {
        var dataArr = [],
            layersCnt = data.length / 2,
            innerInx = 0,
            pageArr = [],
            dLen = data.length,
            doubleSlides,
            lastPageSlidesCnt = 0;

        if (layersCnt % 2 !== 0) {
            layersCnt = Math.round(layersCnt);
        }

        if (layersCnt === 0) {
            layersCnt = 1;
        }

        if (frontCover) {
            dataArr = [
                [frontCover, data[0]]
            ];
            innerInx++;
        }

        for (var i = 0; i < layersCnt && innerInx < dLen; i++) {
            pageArr = [data[innerInx]];

            if (innerInx + 1 < dLen) {
                pageArr.push(data[innerInx + 1]);
            }

            dataArr.push(pageArr);
            innerInx += 2;
        }


        if (promoLastPage) {
            lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(promoLastPage);
            } else {
                dataArr.push([promoLastPage]);
            }
        }

        if (typeof specificPromoPage !== 'undefined' && specificPromoPage && promoSpecificLastPage) {
            var lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(promoSpecificLastPage);
            } else {
                dataArr.push([promoSpecificLastPage]);
            }
        }

        if (backCover) {
            lastPageSlidesCnt = dataArr[dataArr.length - 1].length;

            if (lastPageSlidesCnt == 1) {
                dataArr[dataArr.length - 1].push(backCover);
            } else {
                if (typeof relatedPage !== 'undefined') {
                    dataArr.push([backCover, relatedPage]);
                } else {
                    dataArr.push([backCover]);
                }
            }
        }

        doubleSlides = _generateDoubleModeSlides(dataArr, isRelatedBrochure);

        return doubleSlides;
    }

    function _getXmlData(data, frontCover, backCover, promoLastPage) {
        //dummy data

        var xmlDataObj = {},
            pages = [],
            thumbImg = '';

        xmlDataObj.xml = data;
        xmlDataObj.singlePageItems = [];
        xmlDataObj.doublePageItems = [];

        for (var pageInx = 0, pageLen = data.pages.length; pageInx < pageLen; pageInx++) {
            var page = data.pages[pageInx],
                // pageHtmlTpl = document.createDocumentFragment();
                pageHtmlTpl = document.createElement('div');
            pageHtmlTpl.className = 'xml-slide-inner-wrap',
                pageObj = {};

            if (typeof page.products !== 'undefined' && page.products.length) {
                for (var i = 0, len = page.products.length; i < len; i++) {
                    var product = page.products[i],
                        pageProductsHtml = _generataeProductPageTpl(product, page);

                    pageHtmlTpl.appendChild(pageProductsHtml);
                }
            } else if (page.url) {

            }

            if (product && product.imageUrl) {
                thumbImg = product.imageUrl;
            } else if (page && page.background_image) {
                thumbImg = page.background_image;
            }

            pageObj = {
                html: pageHtmlTpl,
                thumbImage: { src: thumbImg },
                w: _pageSize.w,
                h: _pageSize.h,
                backgroundImage: page.background_image,
                backgroundColor: page.background_color,
                pageLogo: page.page_logo,
                pageLogoUrl: page.page_logo_url,
                inx: pageInx,
                additional_page: page.additional_page && true,
                number_of_products: page.number_of_products
            };

            if (typeof data.extensions !== 'undefined' && data.extensions.pins) {
                pageObj.pins = data.extensions.pins[pageInx];
            } else {
                pageObj.pins = [];
            }

            if (page.additional_page) {
                pageObj.w = page.width;
                pageObj.h = page.height;
                pageObj.thumbImage = pageObj.mediumImage = pageObj.largeImage = { src: page.backgroundImage, h: page.height, w: page.width };
            }

            pages.push(pageObj);
        }

        return pages;
    }

    function _formatTitle(title){ 
    	var formatedTitle;
    	if(typeof title == 'string'){
    		formatedTitle = title.substring(0,16);
    		return formatedTitle;
    	}else{
    		return '';
    	}
    }


    function _formatPrice(price) {
        var price = typeof price !== 'undefined' ? '' + price : price;

        if (viewSettings.isRedesign === false || typeof viewSettings.isRedesign === "undefined") {
	        if (price.indexOf(".00") > -1) {
	            price = price.substring(price.indexOf(".00"), 0);
	        }
	     }

        //Todo: separate decimals 
        if (viewSettings.isRedesign === true) {
            price = _formatThousandsWithRounding(parseFloat(price), 2);
            var priceSeparated = price.split('.');
            return priceSeparated;

        }

        return price;
    }

    function _formatThousandsWithRounding(n, dp) {
        var w = n.toFixed(dp),
            k = w | 0,
            b = n < 0 ? 1 : 0,
            u = Math.abs(w - k),
            d = ('' + u.toFixed(dp)).substr(2, dp),
            s = '' + k,
            i = s.length,
            r = '',
            thousandsDelimeter = ' ';

        while ((i -= 3) > b) { r = thousandsDelimeter + s.substr(i, 3) + r; }

        return s.substr(0, i + 3) + r + (d ? '.' + d : '');
    }

    function _init() {

    }


    _this.init = _init;
    _this.getXmlData = _getXmlData;
    _this.buildSingleContent = _buildSingleContent;
    _this.buildDoubleContent = _buildDoubleContent;
};